import {submitButtonIsActive} from "../commons/validation";
window.addEventListener('load', ()=>{
  submitButtonIsActive('privacyPolicyFlag');
});

document.getElementById('privacyPolicyFlag').addEventListener('change', ()=>{
  submitButtonIsActive('privacyPolicyFlag');
});